/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ObjectUploadResponse { 
    kind?: string;
    id?: string;
    selfLink?: string;
    mediaLink?: string;
    name?: string;
    bucket?: string;
    generation?: string;
    metageneration?: string;
    contentType?: string;
    storageClass?: string;
    size?: string;
    md5Hash?: string;
    crc32c?: string;
    etag?: string;
    timeCreated?: string;
    updated?: string;
    timeStorageClassUpdated?: string;
}

